import { render, staticRenderFns } from "./SoftwareInformation.vue?vue&type=template&id=067d1ba2&scoped=true"
import script from "./SoftwareInformation.vue?vue&type=script&lang=js"
export * from "./SoftwareInformation.vue?vue&type=script&lang=js"
import style0 from "./SoftwareInformation.vue?vue&type=style&index=0&id=067d1ba2&prod&scoped=true&lang=css"
import style1 from "./SoftwareInformation.vue?vue&type=style&index=1&id=067d1ba2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067d1ba2",
  null
  
)

export default component.exports